<template>
	<div class="wrapper">
		<template v-if="$store.state.authentication.mode != 'driver' ">
			<side-bar v-if="$store.state.authentication.account_type == 'ca'">
				<sidebar-link to="/new_package">
					<md-icon>add_circle_outline</md-icon>
					<p>បញ្ចូលកញ្ចប់ឥវ៉ាន់ថ្មី</p>
				</sidebar-link>
				<sidebar-link to="/packages">
					<md-icon>card_giftcard</md-icon>
					<p>កញ្ចប់ឥវ៉ាន់</p>
				</sidebar-link>
				<sidebar-link to="/error_packages">
					<md-icon>error</md-icon>
					<p>កញ្ចប់ឥវ៉ាន់មានបញ្ហា</p>
				</sidebar-link>
				<sidebar-link to="/clients">
					<md-icon>groups</md-icon>
					<p>អតិថិជន</p>
				</sidebar-link>
				<sidebar-link to="/referral">
					<md-icon>diversity_3</md-icon>
					<p>អ្នកទីផ្សារ</p>
				</sidebar-link>
				<sidebar-link to="/payments">
					<md-icon>paid</md-icon>
					<p>ការទូទាត់ប្រាក់</p>
				</sidebar-link>
			</side-bar>
			<side-bar v-if="$store.state.authentication.account_type == 'ad'">
				<sidebar-link to="/dashboard">
					<md-icon>dashboard</md-icon>
					<p>របាយការណ៏</p>
				</sidebar-link>
				<sidebar-link to="/new_package">
					<md-icon>add_circle_outline</md-icon>
					<p>បញ្ចូលកញ្ចប់ឥវ៉ាន់ថ្មី</p>
				</sidebar-link>
				<sidebar-link to="/packages">
					<md-icon>card_giftcard</md-icon>
					<p>កញ្ចប់ឥវ៉ាន់</p>
				</sidebar-link>
				<sidebar-link to="/error_packages">
					<md-icon>error</md-icon>
					<p>កញ្ចប់ឥវ៉ាន់មានបញ្ហា</p>
				</sidebar-link>
				<sidebar-link to="/payments">
					<md-icon>paid</md-icon>
					<p>ការទូទាត់ប្រាក់</p>
				</sidebar-link>
				<sidebar-link to="/clients">
					<md-icon>groups</md-icon>
					<p>អតិថិជន</p>
				</sidebar-link>
				<sidebar-link to="/referral">
					<md-icon>diversity_3</md-icon>
					<p>អ្នកទីផ្សារ</p>
				</sidebar-link>
				<sidebar-link to="/drivers">
					<md-icon>two_wheeler</md-icon>
					<p>អ្នកដឹកជញ្ជូន</p>
				</sidebar-link>
				<sidebar-link to="/zones">
					<md-icon>map</md-icon>
					<p>តំបន់ដឹកជញ្ជូន</p>
				</sidebar-link>
			</side-bar>

			<side-bar v-if="$store.state.authentication.account_type == 'sl'">
				<sidebar-link to="/payments">
					<md-icon>paid</md-icon>
					<p>ការទូទាត់ប្រាក់</p>
				</sidebar-link>
			</side-bar>

			<side-bar v-if="$store.state.authentication.account_type == 'da'">
				<sidebar-link to="/payments">
					<md-icon>paid</md-icon>
					<p>ការទូទាត់ប្រាក់</p>
				</sidebar-link>
			</side-bar>

			<side-bar v-if="$store.state.authentication.account_type == 'sa'">
				<sidebar-link to="/dashboard">
					<md-icon>dashboard</md-icon>
					<p>របាយការណ៏</p>
				</sidebar-link>
				<sidebar-link to="/new_package">
					<md-icon>add_circle_outline</md-icon>
					<p>បញ្ចូលកញ្ចប់ឥវ៉ាន់ថ្មី</p>
				</sidebar-link>
				<sidebar-link to="/packages">
					<md-icon>card_giftcard</md-icon>
					<p>កញ្ចប់ឥវ៉ាន់</p>
				</sidebar-link>
				<sidebar-link to="/error_packages">
					<md-icon>error</md-icon>
					<p>កញ្ចប់ឥវ៉ាន់មានបញ្ហា</p>
				</sidebar-link>
				<sidebar-link to="/payments">
					<md-icon>paid</md-icon>
					<p>ការទូទាត់ប្រាក់</p>
				</sidebar-link>
				<sidebar-link to="/transactions">
					<md-icon>history</md-icon>
					<p>ប្រវត្តិប្រតិបត្តិការ</p>
				</sidebar-link>
				<sidebar-link to="/clients">
					<md-icon>groups</md-icon>
					<p>អតិថិជន</p>
				</sidebar-link>
				<sidebar-link to="/referral">
					<md-icon>diversity_3</md-icon>
					<p>អ្នកទីផ្សារ</p>
				</sidebar-link>
				<sidebar-link to="/drivers">
					<md-icon>two_wheeler</md-icon>
					<p>អ្នកដឹកជញ្ជូន</p>
				</sidebar-link>
				<sidebar-link to="/zones">
					<md-icon>map</md-icon>
					<p>តំបន់ដឹកជញ្ជូន</p>
				</sidebar-link>
				<sidebar-link to="/settings">
					<md-icon>settings</md-icon>
					<p>ការកំណត់</p>
				</sidebar-link>
				<sidebar-link to="/administrators">
					<md-icon>supervised_user_circle</md-icon>
					<p>ការកំណត់គណនី</p>
				</sidebar-link>
			</side-bar>
		</template>
		<template v-if="$store.state.authentication.mode == 'driver' ">
			<side-bar>
				<sidebar-link to="/driver_packages">
					<md-icon>card_giftcard</md-icon>
					<p>កញ្ចប់ឥវ៉ាន់</p>
				</sidebar-link>
			</side-bar>
		</template>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue